module.exports = __webpack_public_path__ + "img/wow.d30346cf.png";